import StarFilled16 from '@carbon/icons-react/es/star--filled/16';
import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { Caption01, BodyShort01 } from 'components/styles';

type StarRatingRendererTypes = {
  value?: number;
  maxValue: number;
};

const Container = styled(Space)`
  ${Caption01};
  align-items: flex-start;
`;

const ValueText = styled.span`
  ${BodyShort01};
`;

export const StarRatingRenderer = ({
  value,
  maxValue,
}: StarRatingRendererTypes) => {
  return (
    <Container align="center">
      <StarFilled16 fill="var(--warning-border-color)" />

      <Space size={4} align="end">
        <ValueText>{value}</ValueText>
        <span>/</span>
        <span>{maxValue}</span>
      </Space>
    </Container>
  );
};
